module.exports = __webpack_public_path__ + "img/rating-ico-2.e52a8d06.png";